import { object } from 'yup';
import * as validationSchema from './validationSchema';

export const forgotPasswordValidation = object().shape({
  identificationNumber: validationSchema.idNumSchema,
});
